<template>
  <div style="border: 0px solid black; width:100%;">
    <div class="welcome" style="border: 0px solid red;">
      <row style="border:0px solid green;position: inherit;display:contents;width:100%;">
        <div class="box box-success" v-show="true">
          <div
            class="box-header with-border"
            v-show="true"
            style="text-align:center; font-size: 14px;text-align:left;color:#5b6c7f;"
          >
            <h3 class="box-title">{{$t('search.title')}}</h3>
            <!-- <lte-button
              style="float:right; display:block;"
              type="btn btn-primary"
              right_icon="fa fa-plus"
              @click="addNew($event)"
            >{{$t('Receipt.addnew')}}</lte-button>-->
          </div>
          <div class="box-body">
            <div class="row" style="margin-bottom: 10px;">
              <div class="col-md-12 col-ld-12 col-sd-12">
                <!-- Search date_from -->
                <div class="col-sm-3 col-md-3 col-lg-3">
                  <div class="form-group">
                    <div class="input-group date">
                      <div class="input-group-addon">
                        <i class="fa fa-calendar">
                          <label>
                            <span
                              style="margin-left:5px;display:inline-block;"
                            >{{ $t("search.date_from") }}:</span>
                          </label>
                        </i>
                      </div>
                      <date-picker
                        :config="options"
                        :value="search.from_date"
                        v-model="search.from_date"
                      ></date-picker>
                    </div>
                  </div>
                </div>
                <!-- END Search date_from -->

                <!-- Search date_to -->
                <div class="col-sm-3 col-md-3 col-lg-3">
                  <div class="form-group">
                    <div class="input-group date">
                      <div class="input-group-addon">
                        <i class="fa fa-calendar">
                          <label>
                            <span
                              style="margin-left:5px;display:inline-block;"
                            >{{ $t("search.date_to") }}:</span>
                          </label>
                        </i>
                      </div>
                      <date-picker
                        :config="options"
                        :value="search.to_date"
                        v-model="search.to_date"
                      ></date-picker>
                    </div>
                  </div>
                </div>
                <!-- END - Search date_to -->

                <div class="col-sm-4 col-md-4 col-lg-4">
                  <input
                    type="text"
                    class="form-control"
                    :placeholder="$t('search.send_by_user')"
                    v-model="search.send_by_user"
                  />
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-sm-3 col-md-3 col-lg-3"></div>
              <div class="col-sm-3 col-md-3 col-lg-3"></div>
              <div class="col-sm-3 col-md-3 col-lg-3"></div>

              <div class="col-sm-3 col-md-3 col-lg-3">
                <button
                  type="button"
                  class="btn btn-labeled btn-success pull-right"
                  @click="onSearch"
                >
                  <span class="btn-label">
                    <i class="glyphicon glyphicon-search"></i>
                  </span>
                  {{$t('search.search_button')}}
                </button>
              </div>
            </div>
          </div>
        </div>
        <div class="box box-primary">
          <div class="box-header with-border">
            <div
              style="text-align:center; font-size: 17px;text-align:left;color:#5b6c7f;margin-bottom:20px;"
            >
              <h3 class="box-title">{{$t('sidebar.customerfeedbackmanagement.to_do_list')}}</h3>
            </div>
          </div>
          <div class="box-body">
              <b-table :per-page="perPage" :current-page="currentPage" :items="gridDataToDoList" :fields="gridColumns" class="mt-3" outlined>
                  <template #head()="scope">
                    <div>{{ $t(scope.label) }}</div>
                  </template>
                  <template slot="actions" slot-scope="row">
                    <div class="btn-group">
                      <button type="button" class="btn btn-danger dropdown-toggle" data-toggle="dropdown" aria-expanded="true">
                        <i class="fa fa-fw fa-ellipsis-h"></i>
                      </button>
                      <ul class="dropdown-menu" :style="row.item.todotype == 1 ? 'min-width: 50px; height: 80px': 'min-width: 50px; height:40px'">
                        <li v-show="row.item.todotype == 1"><button
                          class="btn btn-primary btn-sm"
                          style="margin-left: 6px;"
                          @click="onOpenEditInput(row)"
                        >
                          <i class="fa fa-eye"></i>
                        </button></li>
                          <li><button
                          class="btn btn-danger btn-sm"
                          style="margin-left: 6px;"
                          @click="onOpenDelete(row)"
                        >
                          <i class="glyphicon glyphicon-trash"></i>
                        </button></li>
                      </ul>
                    </div>
                </template>
              </b-table>
              <b-pagination
            v-model="currentPage"
            :total-rows="totalRows"
            :per-page="perPage"
            align="right"
            size="sm"
            class="mt-0"
          ></b-pagination>
          </div>
        </div>
       
        <lte-core-alert v-for="snackbar in GET_SNACK_BAR" :key="snackbar.id" :item="snackbar"></lte-core-alert>
        <loading :active.sync="isLoading" :can-cancel="false" color="#1E90FF"></loading>

    <div class="modal fade" :ref="`modal-pkg-tmpl`">
      <div class="modal-dialog">
        <confirm
          :id="pkg_tmpl_data.id"
          @confirm="onDeleteConfirm"
        />
      </div>
      <!-- /.modal-dialog -->
    </div>

      </row>
    </div>
  </div>
</template>


<script>
import { mapGetters, mapActions } from "vuex";
import LTECoreAlert from "@/components/LTESnackBar.vue";
// import utils from '@/lib/utils'
import Confirm from "@/components/Confirm.vue"
import datePicker from "vue-bootstrap-datetimepicker";
import Loading from "vue-loading-overlay";

export default {
  name: "TodoList",
  data() {
    return {
      gridDataToDoList: [],
      useFilter: false,
      boxStyle: false,
      currentPage:1,
      totalRows:1,
      perPage: 50,
      gridColumns: [
        { label: "common.nonumber" ,key: "nonumber",  sortable: true,
          class: "text-center "},
        { label: "todolist.message" ,key: "message",  sortable: true,
          class: "align-left "},
        { label: "todolist.receipt" ,key: "receipt",  sortable: true,
        class: "text-center "},
        { label: "todolist.sender" ,key: "sender",  sortable: true,
        class: "text-center "},
        { key: "actions", label: "common.action", sortable: false}
      ],
      actions: ["common.view", "common.delete"],
      ex_actions: ["common.delete"],
      //hdBackground         : "background-color: #4b646f;color:white;border-bottom:2px solid #f4f4f4;", //00a65a
      hdBackground:
        "background-color: #4b646f;color:white;border:1px solid white;", //00a65a
      originalRecordData: [],
      isModalVisible: false,
      dateOptions: {
        format: "YYYY-MM-DD hh:mm a"
      },
      dateOptionsNoTime: {
        format: "DD-MM-YYYY"
      },
      paginatorItem: {
        commit_function: "GET_TODO_LIST"
      },
      pkg_tmpl_data:{
        id:0
      },
      isLoading: false,
      search: {
        from_date: null,
        to_date: null,
        send_by_user: ""
      },
      options: {
        format: "DD/MM/YYYY",
        useCurrent: false
      }
    };
  },
  watch: {
    TODO_LIST_DATA: function() {
      this.gridDataToDoList = [];
      this.TODO_LIST_DATA.forEach((element, i) => {
        let todo_id = element.id;
        let id = element.params.id;
        let nonumber =
          i + 1 + (this.PAGINATION.page - 1) * this.PAGINATION.size;
        let message = element.message;
        let receipt =
          element.profile.receipt_last_name +
          " " +
          element.profile.receipt_first_name;
        let sender =
          element.profile.sender_first_name +
          " " +
          element.profile.sender_last_name;
        let deleted = element.is_deleted;
        let todo_type= element.todo_type;
        let data = {
          id: id,
          todotype : todo_type,
          todo_id: todo_id,
          is_deleted: deleted,
          nonumber: nonumber,
          message: message,
          receipt: receipt,
          sender: sender
        };
        this.gridDataToDoList.push(data);
      });
      this.totalRows = this.gridDataToDoList.length
    }
  },
  computed: {
    ...mapGetters([
      "GET_SNACK_BAR",
      "PAGINATION",
      "TODO_LIST_DATA",
      "PAGINATOR",
      "PAGE_ARROW",
      "GET_CASE_SUB_TYPE_LIST",
      "GET_CUSTOMIZE_TABLE_PERSONAL_CONFIG_DATA",
      "GET_LANG"
    ])
  },

  methods: {
    ...mapActions([
      "ERROR_TOAST",
      "SUCCESS_TOAST",
      "PAGINATION_PREV_PAGE",
      "PAGINATION_NEXT_PAGE",
      "GET_TODO_LIST",
      "DELETE_TODO",
      // "SAVE_CUSTOMIZE_TABLE_PERSONAL_CONFIG",
      // "DELETE_CASE"
    ]),
    onSearch: function() {
      const data = {
        params: {
          page: 1,
          from_date: this.search.from_date,
          to_date: this.search.to_date,
          send_by_user: this.search.send_by_user
        }
      };
      this.isLoading = true;
      this.GET_TODO_LIST(data).then(
        function() {
          this.isLoading = false;
        }.bind(this)
      );
    },
    onOpenEditInput: function(row) {
      let id = row.item.id
      this.$router.push({
        name: "CaseAdd",
        params: {
          id: id
        }
      });
    },
    onOpenDelete: function(row) {
      this.pkg_tmpl_data.id = row.item.todo_id
      this.onToggleDeleteConfirm()
    },
    onToggleDeleteConfirm: function(action="show") {
      $(this.$refs[`modal-pkg-tmpl`]).modal(action)
    },
    onDeleteConfirm: function(id) {
      const payload = {
        id: id
      }
       this.DELETE_TODO(payload)
        .then(
          function() {
            let currentPage = this.PAGINATION.page;
            let totalPage = this.PAGINATOR.length;
            let page =
              currentPage >= totalPage && this.gridDataToDoList.length == 1
                ? totalPage >= 2 ? totalPage - 1 : 1
                : currentPage;
            const data = {
              params: {
                page: page
              }
            };
            this.onToggleDeleteConfirm("hide")
            this.GET_TODO_LIST(data);
            this.SUCCESS_TOAST();
          }.bind(this)
        )
        .catch(
          function() {
            this.ERROR_TOAST();
          }.bind(this)
        );
    },
    closeModal() {
      this.isModalVisible = false;
    },
  },

  components: {
    loading: Loading,
    "date-picker": datePicker,
    "confirm" : Confirm,
    "lte-core-alert":LTECoreAlert
  },

  mounted() {
    const data = {
      params: {
        page: 1
      }
    };
    this.GET_TODO_LIST(data);
  }
};
</script>





// WEBPACK FOOTER //
// src/views/Case/TodoList.vue